module.exports = __webpack_public_path__ + "img/unionpay.40ead9ad.png";